import React from 'react'
import PropTypes from 'prop-types'
import cn from 'clsx'
import { ChevronDown, ChevronUp } from '@ow/icons'

import SortOrder from './SortOrder'

const Icon = ({ desc }) => {
  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{ height: '45px', padding: '5px 0 0 0' }}
    >
      <ChevronUp fill={!desc && 'var(--ow-color-primary-700)'} />
      <div className="-mt-2">
        <ChevronDown fill={desc && 'var(--ow-color-primary-700)'} />
      </div>
    </div>
  )
}

/**
 * default SortIndicator for BaseTable
 */
const SortIndicator = ({ sortOrder, className, style }) => {
  console.log(sortOrder, 'sortOrder9999')
  const cls = cn('BaseTable__sort-indicator', className, {
    'BaseTable__sort-indicator--descending': sortOrder === SortOrder.DESC,
  })
  return (
    <div
      className={cls}
      style={{
        userSelect: 'none',
        textAlign: 'center',
        ...style,
      }}
    >
      <Icon desc={sortOrder === SortOrder.DESC} />
    </div>
  )
}

SortIndicator.propTypes = {
  sortOrder: PropTypes.oneOf([SortOrder.ASC, SortOrder.DESC]),
  className: PropTypes.string,
  style: PropTypes.shape({}),
}

export default SortIndicator
